import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getAnalytics, isSupported } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Auth only
// All database operations go through backend API
export const auth = getAuth(app);

// Analytics — promise that resolves to the Analytics instance once the
// browser environment is verified to support it (e.g. not SSR, not in
// some Safari private windows). Consumers should await this before logging.
export const analyticsPromise = isSupported()
  .then((ok) => (ok && firebaseConfig.measurementId ? getAnalytics(app) : null))
  .catch(() => null);

export default app;
